import type { XlsxFile } from './xlsxFile';

// Not abstract so TypeScript doesn't complain about inability to instantiate
// abstract classes
export class OpenXmlPart {
  public readonly dom: XMLDocument;

  constructor(
    public readonly partPath: string,
    public readonly originalXml: string,
    public readonly xlsxFile: XlsxFile,
  ) {
    this.dom = xlsxFile.parser.parseFromString(originalXml, 'text/xml');
  }

  /**
   * Initializes the part. Anything that depends on other parts should be done
   * here. Anything that doesn't depend on other parts should be done in the
   * part's constructor.
   */
  public init(): void {}

  public save(): string {
    return new XMLSerializer().serializeToString(this.dom);
  }
}
